import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Reagent } from 'entities/reagent'
import { ReactNode, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Form } from 'utils/hooks'

export const reagentColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, align: 'center', form: form, orderAttr: 'reagent_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '試薬名', th: true, minWidth: 200, form: form, orderAttr: 'reagent_name', searchType: { name: 'name', type: 'text' } },
            {
                name: '保存方法',
                th: true,
                width: 100,
                align: 'center',
                form: form,
                orderAttr: 'reagent_preservation',
                searchType: { name: 'preservation', type: 'text' },
            },
            { name: 'ロット数', th: true, width: 100, align: 'center' },
        ],
    }
}

export type ReagentTableDataProps = {
    reagent?: Reagent
    displaySetting: DisplaySetting
}

export const ReagentTableData = ({ reagent, displaySetting }: ReagentTableDataProps): JSX.Element => {
    if (!reagent) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{reagent.id}</TableCell>
                <TableCell>{reagent.name}</TableCell>
                <TableCell align="center">{reagent.preservation}</TableCell>
                <TableCell align="center">
                    <Link to={`reagent_items?reagentId=${reagent.id}`}>{reagent.itemCount}個</Link>
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
